import {getRouter} from '@/router';

import settings from '@/config/settings';
import type {ISettingsParent} from '@/config/types';

const subordinationHook = () => {
  const parent = window.parent;

  const linkClickHandler = (href: string) => {
    if (!parent) return;
    parent.postMessage(
      {
        type: 'tarvos:linkClick',
        id: settings.PARENT.ID,
        href,
      },
      '*',
    );
  };

  const statusUpdateHandler = () => {
    if (!parent) return;
    parent.postMessage(
      {
        type: 'tarvos:statusUpdate',
        id: settings.PARENT.ID,
      },
      '*',
    );
  };

  const init = () => {
    if (!parent) return;
    parent.postMessage(
      {
        type: 'tarvos:getConfig',
        src: window.location.toString(),
      },
      '*',
    );
  };

  window.addEventListener('message', (message) => {
    if (!message.data?.type?.startsWith('tarvos:')) return;
    switch (message.data?.type) {
      case 'tarvos:setConfig':
        settings.PARENT = message.data?.config as ISettingsParent;
        break;
      case 'tarvos:setLink':
        getRouter().push(message.data?.href);
        break;
      default:
        break;
    }
  });

  return {
    init,

    linkClickHandler,
    statusUpdateHandler,
  };
};

export const subordination = subordinationHook();
